<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="77" viewBox="0 0 30 77" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M26.5283 76.9943H3.83542C1.91933 76.9943 0.363525 75.5893 0.363525 73.8588V51.8707C0.363525 50.8256 1.30247 49.9727 2.46522 49.9727H27.8985C29.0558 49.9727 30.0002 50.8206 30.0002 51.8707V73.8588C30.0002 75.5893 28.4444 76.9943 26.5283 76.9943Z"
      fill="#EDF5FF"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.0768 6.25391L27.3963 13.718C29.0558 15.2043 30.0002 17.3231 30.0002 19.539V22.9063C30.0002 24.0521 29.0613 24.9871 27.8985 24.9871H2.46522C1.30792 24.9871 0.363525 24.0575 0.363525 22.9063V19.539C0.363525 17.3231 1.30792 15.2098 2.96745 13.718L11.2869 6.25391H19.0768Z"
      fill="#EDF5FF"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.5248 6.97333H10.1292C9.86915 6.97333 9.66113 6.74711 9.66113 6.46433V1.67405C9.66113 0.752193 10.3476 0 11.2005 0H19.4535C20.3011 0 20.9928 0.746537 20.9928 1.67405V6.46433C20.9928 6.74711 20.7848 6.97333 20.5248 6.97333Z"
      fill="#4C81B2"
    />
    <path
      d="M27.8985 33.3164H2.46522C1.30449 33.3164 0.363525 34.248 0.363525 35.3973V39.6779C0.363525 40.8272 1.30449 41.7588 2.46522 41.7588H27.8985C29.0592 41.7588 30.0002 40.8272 30.0002 39.6779V35.3973C30.0002 34.248 29.0592 33.3164 27.8985 33.3164Z"
      fill="#3E678D"
    />
    <path
      d="M27.8985 24.875H2.46522C1.30449 24.875 0.363525 25.8066 0.363525 26.9559V31.2365C0.363525 32.3857 1.30449 33.3174 2.46522 33.3174H27.8985C29.0592 33.3174 30.0002 32.3857 30.0002 31.2365V26.9559C30.0002 25.8066 29.0592 24.875 27.8985 24.875Z"
      fill="#527A9F"
    />
    <path
      d="M27.8985 41.7617H2.46522C1.30449 41.7617 0.363525 42.6934 0.363525 43.8426V48.1232C0.363525 49.2725 1.30449 50.2041 2.46522 50.2041H27.8985C29.0592 50.2041 30.0002 49.2725 30.0002 48.1232V43.8426C30.0002 42.6934 29.0592 41.7617 27.8985 41.7617Z"
      fill="#527A9F"
    />
  </svg>
</template>
